import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { PolicyAddVehicleUiModule } from '@amfam/policy/add-vehicle/ui';
import { PolicyChangeCoverageUiModule } from '@amfam/policy/change-coverage/ui';
import { PolicyPipesModule } from '@amfam/policy/pipes';
import { PolicySharedModule } from '@amfam/policy/shared';
import { PolicyVehicleCoveragesDataAccessModule } from '@amfam/policy/vehicle-coverages/data-access';
import { DsRouterLinkModule } from '@amfam/shared/ui/ds-router-link';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { RiskListModule } from '@amfam/shared/ui/risk-list';
import { BrandDirectivesModule } from '@amfam/shared/utility/brand';
import { ImpersonationModule } from '@amfam/shared/utility/impersonation';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { ChangeCoverageFeaturesEffects } from './+state/change-coverage-feature/change-coverage-feature.effects';
import { AgentHelpComponent } from './agent-help/agent-help.component';
import { AgentNotificationConfirmationComponent } from './agent-notification-confirmation/agent-notification-confirmation.component';
import { ChangeCoverageConfirmationComponent } from './change-coverage-confirmation/change-coverage-confirmation.component';
import { ChangeCoverageContainerComponent } from './change-coverage-container/change-coverage-container.component';
import { ChangeCoverageSummaryComponent } from './change-coverage-summary/change-coverage-summary.component';
import { ChangeCoverageRoutes } from './routes/change-coverage.routes';
import { UpdateCoverageComponent } from './update-coverage/update-coverage.component';

@NgModule({
  imports: [
    CommonModule,
    UiKitModule,
    SharedServicesModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    ImpersonationModule,
    DsRouterLinkModule,
    BrandDirectivesModule,
    PolicyPipesModule,
    RiskListModule,
    PolicyChangeCoverageUiModule,
    RouterModule.forChild(ChangeCoverageRoutes),
    PolicyVehicleCoveragesDataAccessModule,
    PolicyAddVehicleUiModule,

    EffectsModule.forFeature([ChangeCoverageFeaturesEffects]),
    PolicySharedModule
  ],
  declarations: [
    UpdateCoverageComponent,
    ChangeCoverageContainerComponent,
    AgentHelpComponent,
    ChangeCoverageSummaryComponent,
    AgentNotificationConfirmationComponent,
    ChangeCoverageConfirmationComponent
  ]
})
export class PolicyChangeCoverageFeatureModule {}
